import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    backend: {
      loadPath: '/locale/i18n/{{ns}}/{{lng}}.json',
    },
    debug: false,
    ns: ['common', 'dashboard', 'form', 'header', 'footer'],
    interpolation: {
      escapeValue: false,
      formatSeprator: ',',
    },
    react: {
      wait: true,
    },
  });

export default i18n;
